import { IResearchSpendAttribute } from "@/interfaces/research";

export function spendAttributeAddRandomID(attributeArray: IResearchSpendAttribute[]) {
    const arrayManipulated = attributeArray;
    for (const attribute of arrayManipulated) {
        attribute._id = Math.random().toString(36).slice(2); 
    }
    return arrayManipulated;
}